import { Injectable, inject } from '@angular/core';

import { CartFacade } from '../store/cart/cart.facade';

import { campaignCartAlreadyCleared, markCampaignCartCleared } from './campaign-cart-reset';

@Injectable({ providedIn: 'root' })
export class CampaignCartResetService {
  private readonly cart = inject(CartFacade);

  /** Empties the local cart and the backend draft once for this campaign code. */
  reset(code: string): void {
    const normalized = code.trim();
    if (!normalized || campaignCartAlreadyCleared(normalized)) {
      return;
    }

    markCampaignCartCleared(normalized);
    this.cart.clearCart();
  }
}
